import StepLabel from '@material-ui/core/StepLabel';

export default StepLabel;
